export class InitialSignupModel {
      googleIdName: string;
      samsungIdName: string;
      googleID: string;
      MdmSelection: string;
      header: string;
      header1: string;
      description1: string;
      header2: string;
      subheader1: string;
      subheaderDesc1: string;
      subheader2: string;
      subheaderDesc2: string[];
      radioLabel1: string;
      radioLabel2: string;
      radioLabel3: string;
      inputLabel1: string;
      inputLabel2: string;
      header3: string;
      description3: string;
      link1: string;
      googleId: number;
      samsungId: number;
      link: string;
      KmeId: string;
      ZtpId: string;
      ztpSupportArticleHeader: string;
      ztpSupportArticleMessage: string;
      kmeSupportArticleHeader: string;
      kmeSupportArticleMessage: string;
      constructor() {
            this.header = undefined;
            this.header1 = undefined;
            this.description1 = undefined;
            this.header2 = undefined;
            this.subheader1 = undefined;
            this.subheaderDesc1 = undefined;
            this.subheader2 = undefined;
            this.subheaderDesc2 = undefined;
            this.radioLabel1 = undefined;
            this.radioLabel2 = undefined;
            this.radioLabel3 = undefined;
            this.inputLabel1 = undefined;
            this.inputLabel2 = undefined;
            this.header3 = undefined;
            this.description3 = undefined;
            this.link1 = undefined;
            this.link = undefined;
            this.ztpSupportArticleHeader = undefined;
            this.ztpSupportArticleMessage = undefined;
            this.kmeSupportArticleHeader = undefined;
            this.kmeSupportArticleMessage = undefined;
      }
}

export class MdmDetails {
        emmProductCode: string;
        signupStatus: string;
        emmAccountId: string;
        otherProducts: Array<OtherProducts>;
        constructor() {
            this.emmProductCode = undefined;
            this.signupStatus = undefined;
            this.emmAccountId = undefined;
            this.otherProducts = [];
        }
}

export class OtherProducts {
      emmProductCode: string;
      signupStatus: string;
      emmAccountId: string;
      constructor() {
            this.emmProductCode = undefined;
            this.signupStatus = undefined;
            this.emmAccountId = undefined;
      }
  }